import { render, staticRenderFns } from "./FbGenericTemplateSetting.vue?vue&type=template&id=9327aa24"
import script from "./FbGenericTemplateSetting.vue?vue&type=script&lang=js"
export * from "./FbGenericTemplateSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports